module.exports = __webpack_public_path__ + "./docs/img/icon-error_class.afe5aa1185b8367c7607ccf51acfcdee.svg";